import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'
import { deleteSinglePrice, modifySinglePrice } from '../actions/calendars'
import LoadingProgress from './LoadingProgress'
import '../styles/CalendarDetailsView.css'

class Calendar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPriceEntry: null,      // The price entry currently open for inline edit
      editingPriceId: null,          // Id of the price being edited inline
      newPrice: '',                  // Current inline input value
      confirmingDeleteId: null,      // Id of the price pending delete confirmation
      selectedDayEntry: null,
      selectedMonthEntry: null,
      selectedYearEntry: null,
      collapsedMonths: {},
    };
  }

  generateCalendarDays(month, year) {
    const days = [];
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    let firstDayIndex = firstDate.getDay();

    // Adjust firstDayIndex so that 0 represents Monday
    firstDayIndex = (firstDayIndex === 0) ? 6 : firstDayIndex - 1;

    // Add empty slots for the days before the first day of the month
    for (let i = 0; i < firstDayIndex; i++) {
      days.push({ day: null });
    }

    // Add the actual days of the month
    for (let i = 1; i <= lastDate.getDate(); i++) {
      const dayDate = new Date(year, month, i);

      // Correct way to compare dates (ignoring time)
      const priceData = this.props.priceCalendar.find(
        (entry) => {
          const entryDate = new Date(entry.date);
          return (
            entryDate.getDate() === dayDate.getDate() &&
            entryDate.getMonth() === dayDate.getMonth() &&
            entryDate.getFullYear() === dayDate.getFullYear()
          );
        }
      );

      days.push({ day: i, priceData });
    }

    return days;
  }

  getZoneNameOld(zone) {

    switch (zone) {
      case 0:
        return 'GENERAL';
      case 1:
        return 'BAQUEIRA';
      case 2:
        return 'BERET';
      case 3:
        return 'BONAIGUA';
      case 4:
        return 'RUDA';
      case 5:
        return 'BOSQUE';
      default:
        return 'NONE';
    }
  }

  getZoneName(zone) {
    const { customer } = this.props;
    if (!customer || !customer.Zones) return 'NONE';

    const foundZone = customer.Zones.find(z => z.Zone === zone);
    return foundZone ? foundZone.Description : 'NONE';
  }

  getZoneColor(zone) {

    switch (zone) {
      case 0:
        return 'bg-primary';
      case 1:
        return 'bg-white';
      case 2:
        return 'bg-success';
      case 3:
        return 'bg-info';
      case 4:
        return 'bg-warning';
      case 5:
        return 'bg-secondary';
      default:
        return 'bg-danger';
    }
  }

  getTypeName(type) {
    const { category } = this.props;

    if (category === 'BAQUEIRA') {
      switch (type) {
        case 'BN3XL':
          return '2 PAX';
        case 'CN3XL':
          return '3 PAX';
        case 'BW3XL':
          return '4 PAX';
        default:
          return 'NONE';
      }
    } else {
      switch (type) {
        case 'BNS':
          return 'Standard';
        case 'CNS':
          return 'Standard Carga';
        case 'BWS':
          return 'Standard XL';
        case 'CWS':
          return 'Standard Carga XL';
        case 'BNM':
          return 'Medium';
        case 'CNM':
          return 'Medium Carga';
        case 'BWM':
          return 'Medium XL';
        case 'CWM':
          return 'Medium Carga XL';
        case 'BNL':
          return 'Large';
        case 'CNL':
          return 'Large Carga';
        case 'BWL':
          return 'Large XL';
        case 'CWL':
          return 'Large Carga XL';
        case 'BNXL':
          return 'Large 4';
        case 'CNXL':
          return 'Large 4 Carga';
        case 'BWXL':
          return 'Large 4 XL';
        case 'CWXL':
          return 'Large 4 Carga XL';
        case 'BN2XL':
          return 'Large 5';
        case 'CN2XL':
          return 'Large 5 Carga';
        case 'BW2XL':
          return 'Large 5 XL';
        case 'CW2XL':
          return 'Large 5 Carga XL';
        case 'BN3XL':
          return 'Ski';
        case 'CN3XL':
          return 'Ski Carga';
        case 'BW3XL':
          return 'Ski XL';
        case 'CW3XL':
          return 'Ski Carga XL';
        // Voucher/Coupon Types (X and W, no LOCKER prefix)
        case 'XNS':
          return 'Standard Cupón';
        case 'XWS':
          return 'Standard XL Cupón';
        case 'XNM':
          return 'Medium Cupón';
        case 'XWM':
          return 'Medium XL Cupón';
        case 'XNL':
          return 'Large Cupón';
        case 'XWL':
          return 'Large XL Cupón';
        case 'XNXL':
          return 'Large 4 Cupón';
        case 'XWXL':
          return 'Large 4 XL Cupón';
        case 'XN2XL':
          return 'Large 5 Cupón';
        case 'XW2XL':
          return 'Large 5 XL Cupón';
        case 'XN3XL':
          return 'Ski Cupón';
        case 'XW3XL':
          return 'Ski XL Cupón';
        default:
          return 'NONE';
      }
    }
  }

  // Begin inline modification of a price (renders an input inside the cell)
  handleStartModify = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: price._id,
      newPrice: price.price,
      confirmingDeleteId: null,
    });
  };

  // Confirm inline deletion
  handleConfirmDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.props.deleteSinglePrice(price._id);
    this.setState({
      confirmingDeleteId: null,
      selectedPriceEntry: null,
      editingPriceId: null,
      newPrice: '',
    });
  };

  // Ask for delete confirmation inline
  handleAskDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      confirmingDeleteId: price._id,
      editingPriceId: null,
    });
  };

  // Submit inline modification
  handleConfirmModify = (e, price) => {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    const { newPrice } = this.state;
    if (newPrice === '' || isNaN(parseFloat(newPrice))) return;
    this.props.modifySinglePrice(price._id, parseFloat(newPrice));
    this.setState({
      editingPriceId: null,
      selectedPriceEntry: null,
      newPrice: '',
    });
  };

  // Cancel inline edit / delete-confirm
  handleCancelInline = (e) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: null,
      confirmingDeleteId: null,
      newPrice: '',
    });
  };

  toggleMonth = (key) => {
    this.setState(prev => ({
      collapsedMonths: { ...prev.collapsedMonths, [key]: !prev.collapsedMonths[key] }
    }));
  };

  handlePriceChange = (event) => {
    this.setState({ newPrice: event.target.value });
  };

  handlePriceEntryClick = (price, day, month, year) => {
    const wasSelected = this.state.selectedPriceEntry === price;
    this.setState({
      selectedPriceEntry: wasSelected ? null : price,
      selectedDayEntry: day,
      selectedMonthEntry: month,
      selectedYearEntry: year,
      // closing the entry also closes any inline editor on it
      editingPriceId: wasSelected ? null : this.state.editingPriceId,
      confirmingDeleteId: wasSelected ? null : this.state.confirmingDeleteId,
    });
  };

  render() {
    const { startYear, endYear, startMonth, endMonth, customer, loading } = this.props;
    const { selectedPriceEntry, editingPriceId, confirmingDeleteId, newPrice, collapsedMonths } = this.state;

    const pad = n => String(n).padStart(2, '0');
    const todayStr = new Date().toISOString().split('T')[0];

    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Determine the range of months to display
    const monthsToDisplay = [];
    
    // If years are the same, only show months in that year
    if (startYear === endYear) {
      for (let i = startMonth; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
    } else {
      // Show months from startMonth to December in startYear
      for (let i = startMonth; i <= 11; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
      
      // Show months for any full years in between
      for (let year = startYear + 1; year < endYear; year++) {
        for (let i = 0; i <= 11; i++) {
          monthsToDisplay.push({ month: i, year });
        }
      }
      
      // Show months from January to endMonth in endYear
      for (let i = 0; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: endYear });
      }
    }

    if (!customer) {
      return <LoadingProgress />
    }

    return (
      <div className="calendar-wrapper">
        {loading && (
          <div className="calendar-loading-overlay">
            <div className="calendar-spinner"></div>
          </div>
        )}
        {monthsToDisplay.map(({ month, year }) => {
          const days = this.generateCalendarDays(month, year);
          const hasPrices = days.some(day => day.priceData);

          if (!hasPrices) return null;

          const monthPrices = days.reduce((acc, d) => {
            if (d.priceData && d.priceData.prices) {
              d.priceData.prices.forEach(p => { if (p && typeof p.price === 'number') acc.push(p.price); });
            }
            return acc;
          }, []);
          const totalDays = days.filter(d => d.priceData).length;
          const mMin = monthPrices.length ? Math.min(...monthPrices) : null;
          const mMax = monthPrices.length ? Math.max(...monthPrices) : null;
          const mAvg = monthPrices.length ? (monthPrices.reduce((s, v) => s + v, 0) / monthPrices.length) : null;
          const fmtM = v => v === null ? '—' : v.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

          const key = `${month}-${year}`;
          const isCollapsed = !!collapsedMonths[key];

          return (
            <div key={key} className="calendar">
              <div className="calendar-month-header">
                <span className="calendar-month-title">
                  <i className="fas fa-calendar-alt mr-2"></i>{monthNames[month]} {year}
                </span>
                <div className="calendar-month-stats">
                  <span className="month-stat-pill"><i className="fas fa-calendar-check mr-1"></i>{totalDays} días</span>
                  <span className="month-stat-pill low"><i className="fas fa-arrow-down mr-1"></i>{fmtM(mMin)}</span>
                  <span className="month-stat-pill avg"><i className="fas fa-minus mr-1"></i>{fmtM(mAvg)}</span>
                  <span className="month-stat-pill high"><i className="fas fa-arrow-up mr-1"></i>{fmtM(mMax)}</span>
                  <button className="month-collapse-btn" onClick={() => this.toggleMonth(key)}>
                    {isCollapsed
                      ? <span key="closed"><i className="fas fa-chevron-down mr-1"></i>Mostrar</span>
                      : <span key="open"><i className="fas fa-chevron-up mr-1"></i>Ocultar</span>
                    }
                  </button>
                </div>
              </div>
              {!isCollapsed && (
              <div className="calendar-grid">
                {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map((day) => (
                  <div key={day} className="calendar-day-header">{day}</div>
                ))}
                {days.map((day, index) => (
                  <div
                    key={index}
                    className={`calendar-operator-day ${day.day ? (day.priceData ? 'with-price' : 'no-price') : 'no-day'}`}>
                    {day.day && (
                      <>
                        <span className="day-number">{day.day}</span>
                        {day.priceData && (
                          <div className="price-info">
                            {day.priceData.prices
                              .slice() // Create a shallow copy of the array to avoid mutating the original array
                              .sort((a, b) => {
                                const nameA = this.getZoneName(a.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                const nameB = this.getZoneName(b.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                              })
                              .map((price, idx) => {
                                const isEditing = editingPriceId === price._id;
                                const isConfirmingDelete = confirmingDeleteId === price._id;
                                const isSelected = selectedPriceEntry === price;
                                const dayStr = `${year}-${pad(month + 1)}-${pad(day.day)}`;
                                const isPast = dayStr < todayStr;
                                return (
                                  <div
                                    key={idx}
                                    className={`price-entry ${this.getZoneColor(price.zone)}`}
                                    onClick={() => !isEditing && !isConfirmingDelete && this.handlePriceEntryClick(price, day.day, month, year)}
                                  >
                                    {!isEditing && !isConfirmingDelete && (
                                      <span className="price-entry-content">
                                        <span className="price-entry-zone">{this.getZoneName(price.zone).length > 12 ? this.getZoneName(price.zone).slice(0, 12) + '…' : this.getZoneName(price.zone)}</span>
                                        <span className="price-entry-sep">·</span>
                                        <span className="price-entry-type">{this.getTypeName(price.type)}</span>
                                        <span className="price-entry-sep">·</span>
                                        <span className="price-entry-amount">{(price.price).toFixed(2)}€</span>
                                      </span>
                                    )}

                                    {isEditing && (
                                      <form
                                        onSubmit={(e) => this.handleConfirmModify(e, price)}
                                        onClick={(e) => e.stopPropagation()}
                                        className="price-inline-edit"
                                      >
                                        <div className="price-inline-label">
                                          {this.getZoneName(price.zone)} · {this.getTypeName(price.type)}
                                        </div>
                                        <input
                                          type="number"
                                          step="0.01"
                                          autoFocus
                                          required
                                          value={newPrice}
                                          onChange={this.handlePriceChange}
                                          onClick={(e) => e.stopPropagation()}
                                          className="price-inline-input"
                                        />
                                        <div className="price-inline-actions">
                                          <button type="submit" className="price-action-btn confirm" title="Guardar">
                                            <i className="fas fa-check mr-1"></i>Guardar
                                          </button>
                                          <button type="button" className="price-action-btn cancel" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times mr-1"></i>Cancelar
                                          </button>
                                        </div>
                                      </form>
                                    )}

                                    {isConfirmingDelete && (
                                      <div className="price-inline-edit" onClick={(e) => e.stopPropagation()}>
                                        <div className="price-inline-label danger">¿Eliminar este precio?</div>
                                        <div className="price-inline-actions">
                                          <button type="button" className="price-action-btn danger" title="Sí, eliminar" onClick={(e) => this.handleConfirmDelete(e, price)}>
                                            <i className="fas fa-trash mr-1"></i>Eliminar
                                          </button>
                                          <button type="button" className="price-action-btn cancel" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times mr-1"></i>Cancelar
                                          </button>
                                        </div>
                                      </div>
                                    )}

                                    {isSelected && !isEditing && !isConfirmingDelete && (
                                      isPast ? (
                                        <div className="price-past-notice">
                                          <i className="fas fa-lock mr-1"></i>No se pueden modificar precios de fechas pasadas
                                        </div>
                                      ) : (
                                      <div className="price-inline-actions mt-1">
                                        <button className="price-action-btn edit" onClick={(e) => this.handleStartModify(e, price)}>
                                          <i className="fas fa-pen mr-1"></i>Modificar
                                        </button>
                                        <button className="price-action-btn danger" onClick={(e) => this.handleAskDelete(e, price)}>
                                          <i className="fas fa-trash mr-1"></i>Eliminar
                                        </button>
                                      </div>
                                      )
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  priceCalendar: state.calendars.calendar.PriceCalendar,
  calendar: state.calendars.calendar,
  category: state.auth.category,
  loading: state.calendars.loading,
  error: state.calendars.error,
});

const mapDispatchToProps = dispatch => ({
  deleteSinglePrice: bindActionCreators(deleteSinglePrice, dispatch),
  modifySinglePrice: bindActionCreators(modifySinglePrice, dispatch),
  push: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);